import { useService } from '@core/inversify-react';
import { useQuery, UseQueryOptions } from 'react-query';

import { GetFlyexLocationsRepoType, IGetFlyexLocationsRepo } from '../repos';
import { IFlyexLocation } from '../interfaces';

export const useFlyexLocations = (options?: UseQueryOptions<IFlyexLocation[], string, IFlyexLocation[], string[]>) => {
  const getFlyexLocationsRepo = useService<IGetFlyexLocationsRepo>(GetFlyexLocationsRepoType);

  return useQuery<IFlyexLocation[], string, IFlyexLocation[], string[]>(
    ['flyex-locations'],
    async () => {
      const result = await getFlyexLocationsRepo.execute();

      if (result.status === 200) {
        return result.response;
      } else {
        throw result.response;
      }
    },
    options,
  );
};
